import request from '@/utils/request'


// 查询产品定制申请列表
export function listGoodsCustomRequest(query) {
  return request({
    url: '/goods/goods/custom/request/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询产品定制申请分页
export function pageGoodsCustomRequest(query) {
  return request({
    url: '/goods/goods/custom/request/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询产品定制申请详细
export function getGoodsCustomRequest(data) {
  return request({
    url: '/goods/goods/custom/request/detail',
    method: 'get',
    params: data
  })
}

// 新增产品定制申请
export function addGoodsCustomRequest(data) {
  return request({
    url: '/goods/goods/custom/request/add',
    method: 'post',
    data: data
  })
}

// 修改产品定制申请
export function updateGoodsCustomRequest(data) {
  return request({
    url: '/goods/goods/custom/request/edit',
    method: 'post',
    data: data
  })
}

// 删除产品定制申请
export function delGoodsCustomRequest(data) {
  return request({
    url: '/goods/goods/custom/request/delete',
    method: 'post',
    data: data
  })
}

export function batchRejectGoodsCustomRequest(data) {
  return request({
    url: '/goods/goods/custom/request/batchReject',
    method: 'post',
    data: data
  })
}
